import { render, staticRenderFns } from "./SoundTagGroupPicker.vue?vue&type=template&id=6d465dac&scoped=true"
import script from "./SoundTagGroupPicker.vue?vue&type=script&lang=js"
export * from "./SoundTagGroupPicker.vue?vue&type=script&lang=js"
import style0 from "./SoundTagGroupPicker.vue?vue&type=style&index=0&id=6d465dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d465dac",
  null
  
)

export default component.exports